export default __webpack_public_path__ + "static/media/20.3f880b58.svg";